import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDownToLine } from '@fortawesome/pro-light-svg-icons/faArrowDownToLine';
import { faSpinnerThird } from '@fortawesome/pro-light-svg-icons/faSpinnerThird';
import { TypedMemo } from '../../../../common/types';
import { masterPlayerMessages } from './masterPlayerMessages';
import { useMasterDownload } from './useMasterDownload';

interface MasterDownloadButtonProps {
  accountId: number;
  itemUuid: string;
  /** The name of the original file, for the label of the button. */
  fileName: string;
}

/** Downloads the original master under its own name (design release-kit o1, o2). */
const MasterDownloadButtonComponent: React.FC<MasterDownloadButtonProps> = ({ accountId, itemUuid, fileName }) => {
  const intl = useIntl();
  const { download, isLoading } = useMasterDownload({ accountId, itemUuid });
  const onClick = useCallback(() => {
    download().catch(console.error);
  }, [download]);
  return (
    <Button
      size="sm"
      color="secondary"
      className="d-inline-flex align-items-center gap-2 flex-shrink-0"
      onClick={onClick}
      disabled={isLoading}
      aria-label={intl.formatMessage(masterPlayerMessages.downloadLabel, { name: fileName })}
    >
      <FontAwesomeIcon icon={isLoading ? faSpinnerThird : faArrowDownToLine} spin={isLoading} />
      {intl.formatMessage(masterPlayerMessages.download)}
    </Button>
  );
};

export const MasterDownloadButton = TypedMemo(MasterDownloadButtonComponent);
